<script lang="ts">
      import HeroContentBlock from './content/HeroContentBlock.svelte'
      import Gafa from './ui/Gafa.svelte'
      import Backdrop from './ui/Backdrop.svelte'
      import { getScrollContext, type ScrollTracker } from '$lib/ui/scroll/index.svelte'
      import { getHeaderVisiblityContext } from '$lib/ui/menu/index.svelte'
      import Globe from '../ui/Globe.svelte'
      import { getBreakpointContext } from '../context/ts/BreakpointContext.svelte'
      import { untrack } from 'svelte'
      import BackdropPhone from './ui/BackdropPhone.svelte'

      async function handleTapToScroll(e: Event) {
            if (scroll.Y > 0) return
            if (!card) return

            let top = card.getBoundingClientRect()

            document.documentElement.scrollTo({
                  top: top.y + top.height / 2 - document.documentElement.clientHeight / 2,
                  behavior: 'smooth',
            })
      }

      async function updateBlur() {
            if (!container) return false
            const top = container.getBoundingClientRect()
            if (scroll.Y + top.y >= top.y + top.height / 2 - document.documentElement.clientHeight / 2) blur = 1
            else blur = 0
            return true
      }

      $effect(() => {
            scroll.Y
            updateBlur()
      })

      let title: HTMLButtonElement | null = null
      let card: HTMLDivElement | null = null

      let container: HTMLDivElement | null = null

      const scroll: ScrollTracker = getScrollContext()
      const ui = getHeaderVisiblityContext()
      const breakpointContext = getBreakpointContext()


      $effect( () => {
        breakpointContext.portrait
        untrack( () => {
          console.log(breakpointContext.breakpointNumber)
        })
      })

      ui.forceMenuHidden()

      let blur = $state(0)



      let open = true
      let scale = 1

      let { block } = $props()
</script>

{#if breakpointContext.breakpointNumber < 3 }
<BackdropPhone {blur} backdrop={block.backdrop} backdropBlur={block.backdropBlur}></BackdropPhone>
{:else }
<Backdrop {blur} backdrop={block.backdrop} backdropBlur={block.backdropBlur}></Backdrop>
{/if}

<!-- svelte-ignore a11y_click_events_have_key_events -->
<div bind:this={container} class="w-full z-0 h-auto" style="--width: {scroll.Y > 100 ? '100' : '88'}; --opacity: {scroll.Y > 100 ? '100' : '46'}; --open: {scroll.Y > 100 ? 'true' : 'false'};">
  <div class="w-[50%] max-w-xl mx-auto h-screen mb-[-24vh] flex items-center justify-center">
        {#if block.globe}
        <div class="globe w-full mix-blend-difference { scroll.Y > 10 ? "opacity-0" : "" }">
          <Globe></Globe>
        </div>
        {/if}
      </div>
      <div role="button" tabindex="0" onclick={handleTapToScroll} bind:this={card} class="cursor-default w-[100%] cardOpacity py-[10%] overflow-hidden">
            <div
                  class="font-[neue-machina] relative z-10 font font-medium outline-none border-none card h-full text-[#414141] text-xl md:text-3xl xl:text-4xl flex items-center content-center justify-center text-center origin-center mx-auto overflow-visible">
                  <Gafa></Gafa>
                  <div class="z-[1] w-full rounded-xl overflow-hidden">
                        <HeroContentBlock content={block.content}></HeroContentBlock>
                  </div>
            </div>
      </div>
      <!--<div class="h-[40em]"></div>-->
</div>

<style lang="postcss">
    .globe {
      transition: all .9s ease-in-out;
    }

      .cardOpacity {
            opacity: calc(var(--opacity) / 100);
            transition: opacity 0.4s ease-in-out;
      }

      .card {
            @apply w-[88%] max-w-[1260px];
            transition: all 0s ease-in-out;
            /*width: calc(var(--width) * 0.9 * 1%);*/
            transform: scale(calc(var(--scale)), calc(var(--scale)));
      }
</style>
